import { render, staticRenderFns } from "./driverslist.vue?vue&type=template&id=3dad3e4a&scoped=true"
import script from "./driverslist.js?vue&type=script&lang=js&external"
export * from "./driverslist.js?vue&type=script&lang=js&external"
import style0 from "./driverslist.vue?vue&type=style&index=0&id=3dad3e4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dad3e4a",
  null
  
)

export default component.exports